import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Alert, Button, Image, Spin, Typography } from "antd";
import { API_BASE } from "../config/api";

export default function PublicImage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setItem(null);
    setError("");
    setImageFailed(false);
    fetch(`${API_BASE}/public-images/${encodeURIComponent(id)}`, { signal: controller.signal, cache: "no-store" })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(response.status === 404 ? "Esta publicación ya no está disponible." : "No pudimos cargar la imagen. Intentá nuevamente.");
        setItem(data);
      })
      .catch((requestError) => { if (requestError.name !== "AbortError") setError(requestError.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [id]);

  return (
    <main style={{ minHeight: "100vh", background: "#fcfaf6", padding: "30px 16px 50px", textAlign: "center" }}>
      <div style={{ maxWidth: 1050, margin: "0 auto" }}>
        <Link to="/" style={{ color: "#8a6d3b", fontWeight: 800, letterSpacing: 3, fontSize: 13 }}>ESTUDIO ISAAC</Link>
        {loading ? <div style={{ padding: 90 }}><Spin size="large" /></div> : error ? <Alert type="warning" message={error} style={{ margin: "35px auto" }} /> : item && (
          <>
            <Typography.Title level={1} style={{ color: "#30291e", fontSize: "clamp(24px, 5vw, 36px)", margin: "22px 0 12px", overflowWrap: "anywhere" }}>{item.title}</Typography.Title>
            <Typography.Paragraph style={{ color: "#867b68", marginBottom: 24 }}>Tocá la imagen para ampliarla y ver todos los detalles.</Typography.Paragraph>
            <div style={{ padding: 8, borderRadius: 16, background: "#fff", boxShadow: "0 12px 45px rgba(80,61,29,0.1)" }}>
              <Image src={item.imageUrl} alt={item.title} width="100%" style={{ height: "auto", display: "block", borderRadius: 10 }} preview={{ mask: "Ampliar imagen" }} onError={() => setImageFailed(true)} />
            </div>
            {imageFailed && <Alert type="warning" message="No pudimos mostrar la imagen. Intentá recargar la página." style={{ marginTop: 16 }} />}
          </>
        )}
        <Button href="/" size="large" style={{ marginTop: 28, borderColor: "#d9c7a5", color: "#8a6d3b", borderRadius: 10 }}>Ver servicios y reservar</Button>
      </div>
    </main>
  );
}
